import { BASEMAP_OPTIONS, type BasemapId } from "../map/basemaps";

/**
 * Basemap picker — plan-view (2D) only.
 *
 * Axiom Design Core: monospace uppercase labels, hairline border, no fill,
 * no shadow. The previous build used emoji as icons (decorative, and they
 * rasterise differently on every platform), a drop shadow, and a filled
 * accent background on the active item — all prohibited. Active state is
 * now the 2px accent top-edge stripe, the same signal the lens rail uses,
 * and 0.60rem type has been raised to the --size-eyebrow floor.
 */

interface Props {
  current: BasemapId;
  onChange: (id: BasemapId) => void;
}

export function BasemapStrip({ current, onChange }: Props) {
  return (
    <div className="basemap-strip" role="radiogroup" aria-label="Basemap type">
      <span className="basemap-strip-label">BASE</span>
      {BASEMAP_OPTIONS.map((opt) => {
        const active = opt.id === current;
        return (
          <button
            key={opt.id}
            role="radio"
            aria-checked={active}
            onClick={() => onChange(opt.id)}
            title={opt.preview}
            className={`basemap-btn${active ? " is-active" : ""}`}
          >
            {opt.label.toUpperCase()}
          </button>
        );
      })}
    </div>
  );
}
